<template>
  <div>
  <facit-header></facit-header>
    <div class="profile-div col-sm-6">
      <h5 class="mt-3 mb-3"> Generate Key </h5><br><br>
      <b-form @submit.prevent="demoLicence('formRegistration')"
              class="ml-4 mr-4 mb-4"
              data-vv-scope="formRegistration">
        <b-form-group id="nameGroup">
          <b-row class="my-1">
            <b-col sm="4">
              <label for="input-small"> Product Key</label>
            </b-col>
          <b-col sm="8">
            <b-form-input id="key1"
                        name="key1"
                        type="text"
                        v-model="key1"
                        maxlength="1"
                        v-validate="'required|numeric'"
                        style=" width:11% !important; display: inline !important;"
                        :class="{'input': true,
                                  'is-danger': errors.has('formRegistration.key1') }"
                        >
            </b-form-input>

            <b-form-input id="key2"
                        name="key2"
                        type="text"
                        v-model="key2"
                        maxlength="1"
                        v-validate="'required|numeric'"
                        style=" width:11% !important; display: inline !important;"
                        :class="{'input': true,
                                  'is-danger': errors.has('formRegistration.key2') }"
                        >
            </b-form-input>

            <b-form-input id="key3"
                        name="key3"
                        type="text"
                        v-model="key3"
                        maxlength="1"
                        v-validate="'required|numeric'"
                        style=" width:11% !important; display: inline !important;"
                        :class="{'input': true,
                                  'is-danger': errors.has('formRegistration.key3') }"
                        >
            </b-form-input>
            <b-form-input id="key4"
                        name="key4"
                        type="text"
                        v-model="key4"
                        maxlength="1"
                        v-validate="'required|numeric'"
                        style=" width:11% !important; display: inline !important;"
                        :class="{'input': true,
                                  'is-danger': errors.has('formRegistration.key4') }"
                        >
            </b-form-input>
            <b-form-input id="key5"
                        name="key5"
                        type="text"
                        v-model="key5"
                        maxlength="1"
                        v-validate="'required|numeric'"
                        style=" width:11% !important; display: inline !important;"
                        :class="{'input': true,
                                  'is-danger': errors.has('formRegistration.key5') }"
                        >
            </b-form-input>
            <b-form-input id="key6"
                        name="key6"
                        type="text"
                        v-model="key6"
                        maxlength="1"
                        v-validate="'required|numeric'"
                        style=" width:11% !important; display: inline !important;"
                        :class="{'input': true,
                                  'is-danger': errors.has('formRegistration.key6') }"
                        >
            </b-form-input>
            <b-form-input id="key7"
                        name="key7"
                        type="text"
                        v-model="key7"
                        maxlength="1"
                        v-validate="'required|numeric'"
                        style=" width:11% !important; display: inline !important;"
                        :class="{'input': true,
                                  'is-danger': errors.has('formRegistration.key7') }"
                        >
            </b-form-input>
            <b-form-input id="key8"
                        name="key8"
                        type="text"
                        v-model="key8"
                        maxlength="1"
                        v-validate="'required|numeric'"
                        style=" width:11% !important; display: inline !important;"
                        :class="{'input': true,
                                  'is-danger': errors.has('formRegistration.key8') }"
                        >
            </b-form-input>
            <i v-show="errors.has('formRegistration.key1')" class="fa fa-warning"></i>
            <span v-show="errors.has('formRegistration.key1')"
                  class="help is-danger">{{ errors.first('formRegistration.key1') }}
            </span>
            <i v-show="errors.has('formRegistration.key2')" class="fa fa-warning"></i>
            <span v-show="errors.has('formRegistration.key2')"
                  class="help is-danger">{{ errors.first('formRegistration.key2') }}
            </span>
            <i v-show="errors.has('formRegistration.key3')" class="fa fa-warning"></i>
            <span v-show="errors.has('formRegistration.key3')"
                  class="help is-danger">{{ errors.first('formRegistration.key3') }}
            </span>
            <i v-show="errors.has('formRegistration.key4')" class="fa fa-warning"></i>
            <span v-show="errors.has('formRegistration.key4')"
                  class="help is-danger">{{ errors.first('formRegistration.key4') }}
            </span>
            <i v-show="errors.has('formRegistration.key5')" class="fa fa-warning"></i>
            <span v-show="errors.has('formRegistration.key5')"
                  class="help is-danger">{{ errors.first('formRegistration.key5') }}
            </span>
            <i v-show="errors.has('formRegistration.key6')" class="fa fa-warning"></i>
            <span v-show="errors.has('formRegistration.key6')"
                  class="help is-danger">{{ errors.first('formRegistration.key6') }}
            </span>
            <i v-show="errors.has('formRegistration.key7')" class="fa fa-warning"></i>
            <span v-show="errors.has('formRegistration.key7')"
                  class="help is-danger">{{ errors.first('formRegistration.key7') }}
            </span>
            <i v-show="errors.has('formRegistration.key8')" class="fa fa-warning"></i>
            <span v-show="errors.has('formRegistration.key8')"
                  class="help is-danger">{{ errors.first('formRegistration.key8') }}
            </span>
            </b-col>
          </b-row>
        </b-form-group>
        <b-button
          type="submit"
          class="w-100"
          variant="warning">Submit</b-button>
      </b-form><br>
      <b-modal v-model="payAsGoLicence" hide-footer title="Licence Key">
        {{payLicenceKey}}
      </b-modal>
    </div>
    <div class = "profile-div col-12">
    <b-table  striped hover
              :fields="fields"
              :items="licence">
      <template slot="totalCost" slot-scope="data">
        {{`£${data.value}.00`}}
      </template>
    </b-table>
  </div>
  </div>
</template>

<script>
import API from '@/api';
import Session from '@/Session';
import FacitHeader from '@/components/header';
import VueRecaptcha from 'vue-recaptcha';

export default {
  name: 'licence',
  components: { FacitHeader},
  data() {
    return {
      key1: 0,
      key2: 0,
      key3: 0,
      key4: 0,
      key5: 0,
      key6: 0,
      key7: 0,
      key8: 0,
      payAsGoLicence: false,
      payLicenceKey: null,
      licence: [],
      fields: [
        {
          key: 'issueDate',
          label: 'Issue Date',
          sortable: true,
          formatter: (value) => {
            const fullDate = new Date(value);
            let day = fullDate.getDate();
            let month = fullDate.getMonth() + 1;
            const year = fullDate.getFullYear();
            const hour = fullDate.getHours();
            const min = fullDate.getMinutes();
            const sec = fullDate.getSeconds();
            if (day < 10) { day = `0${day}`; }
            if (month < 10) { month = `0${month}`; }
            return `${day}-${month}-${year} ${hour}:${min}:${sec}`;
          },
        },
        {
          key: 'productKey',
          label: 'Product Key',
          sortable: true,
        },
        {
          key: 'licenceKey',
          label: 'Licence Key',
          sortable: true,
        },
        {
          key: 'totalCost',
          label: 'Total Cost',
          sortable: true,
        },
      ],
    };
  },
  created() {

    const customMessage = {
      attributes: {
      key1: 'Product Key',
      key2: 'Product Key',
      key3: 'Product Key',
      key4: 'Product Key',
      key5: 'Product Key',
      key6: 'Product Key',
      key7: 'Product Key',
      key8: 'Product Key',
    },
  };
  this.$validator.localize('en', customMessage);
  this.getLicence();
  },
  methods: {
    async getLicence() {
      const id = Session.getAccessToken().user.id;
      const downloads = await API.get(`Accounts/${id}/Licence?filter={"order": "id DESC"}`);
      this.licence = downloads
    },
    async demoLicence(scope) {
      try {
        const id = Session.getAccessToken().user.id;
        const validation = await this.$validator.validateAll(scope);
        if (validation) {
          const productKey = `${this.key1}${this.key2}${this.key3}${this.key4}${this.key5}${this.key6}${this.key7}${this.key8}`
        const licence = await API.post(`Accounts/${id}/Licence`, {
          productKey: productKey,
        });
        this.payLicenceKey = licence.licenceKey
        this.getLicence();
        this.payAsGoLicence = true;
      }
      } catch (error) {
        const message = error.response.data.error.message;
        if (message.match(/Invalid Product Key/gi)) {
          this.$notify({
            group: 'sitewide',
            title: 'Error!',
            type: 'error',
            text: 'Invalid Product Key',
          });
        }
      }
    },
    async onVerify(response) {
      if (response) {
        this.disabledButton = false;
      }
    },
    onExpired() {

    },
    redirect() {
      this.$router.push('/');
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.profile-div {
  margin-top: 50px;
  margin-left: 50px;
}
.btn-warning {
  color: #fff;
  background-color: #ff8f00;
  border-color: #ff8f00;
}
.help.is-danger {
    color: #ff3860;
}
.help {
    display: block;
    font-size: 11px;
    margin-top: 5px;
}
span {
    font-style: inherit;
    font-weight: inherit;
}
*, :after, :before {
    box-sizing: inherit;
}
table > thead {
    display:none !important;
}
.table {
  width: 90% !important;
}
</style>



// WEBPACK FOOTER //
// src/components/licence.vue